import { useEffect, useState } from 'react'
import { Button } from 'antd'

// Component
import Loader from '../components/Loader'

import { getLeagueStandings } from '../redux'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import MainHeader from '../components/MainHeader'

const LeagueStandings = () => {
  const setting = useSelector((state) => state?.user?.setting)
  const USER = useSelector((state) => state.user.userDetails)
  const [loading, setLoading] = useState(true)
  const [standingsData, setStandingsData] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const [activeBtn, setActiveBtn] = useState('Overall')
  const [hoverId, setHoverId] = useState('')

  const navigate = useNavigate()

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      let data = await getLeagueStandings(setting?.date)
      setStandingsData(data)
      setLoading(false)
    }
    getData()
  }, [setting?.date])

  useEffect(() => {
    if (standingsData) {
      if (activeBtn === 'Overall') {
        let all = []
        Object.entries(standingsData).map(([key, value]) => {
          if (key.includes('Conference')) {
            all.push(...value)
          }
        })
        setFilteredData(all)
      } else {
        if (standingsData?.hasOwnProperty(activeBtn)) {
          setFilteredData(standingsData[activeBtn])
        }
      }
    }
  }, [standingsData, activeBtn])

  const handleRosterNavigate = (id, teamName, teamLogo) => {
    if (USER?.team?._id === id) {
      navigate(`/player-roster`)
    } else {
      navigate(`/team-roster/${id}`, {
        state: {
          teamName,
          teamLogo,
        },
      })
    }
  }

  const handleLineUpNavigate = (id, teamName) => {
    if (USER?.team?._id === id) {
      navigate(`/team-line`)
    } else {
      navigate(`/team-view-line-up/${id}`, {
        state: {
          teamName,
        },
      })
    }
  }

  return (
    <div className='new_ls_container'>
      <MainHeader heading={'Standings'} />

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className='button_container'>
            <Button
              type='primary'
              onClick={() => setActiveBtn('Overall')}
              className={`${activeBtn === 'Overall' ? 'active' : ''}`}
            >
              Overall
            </Button>
            {Object.entries(standingsData).map((v, i) => {
              return (
                <Button
                  key={i}
                  type='primary'
                  onClick={() => setActiveBtn(v[0])}
                  className={`${activeBtn === v[0] ? 'active' : ''}`}
                >
                  {v[0]}
                </Button>
              )
            })}
          </div>

          <div className='ls_card_box'>
            <div className='ls_card_wrapper'>
              <div className='ls_card_header'>
                <div className='ls_serial_number'>
                  <p></p>
                </div>
                <div className='ls_team_name'>
                  <p>Team</p>
                </div>
                <div className='ls_other_column'>
                  <p>FPts</p>
                </div>
                <div className='ls_other_column'>
                  <p>+/-</p>
                </div>
                <div className='ls_other_column'>
                  <p>FP/G</p>
                </div>
                <div className='ls_other_column'>
                  <p>GP</p>
                </div>
                <div className='ls_other_column'>
                  <p>Skt</p>
                </div>
                <div className='ls_other_column'>
                  <p>Goal</p>
                </div>
                <div className='ls_other_column'>
                  <p>PBL</p>
                </div>
              </div>
              {filteredData
                ?.sort((a, b) => b.teamScore?.teamScore?.pf - a.teamScore?.teamScore?.pf)
                ?.map((v, i) => {
                  return (
                    <div key={i} className='ls_card_inner_wrapper'>
                      <div className='ls_card_inner_header'>
                        <p
                          onClick={() =>
                            // navigate('/game-details', {
                            //   state: {
                            //     teamId: v?.teamScore?.teamId,
                            //     teamName: v?.name,
                            //     teamLogo: v?.logo,
                            //     day: v?.teamScore?.teamScore?.score,
                            //     season: v?.teamScore?.teamScore?.pf,
                            //   },
                            // })
                            navigate('/live-scoring', {
                              state: {
                                teamId: v?.teamScore?.teamId,
                                // teamName: v?.name,
                                // teamLogo: v?.logo,
                                // day: v?.teamScore?.teamScore?.score,
                                // season: v?.teamScore?.teamScore?.pf,
                              },
                            })
                          }
                        >
                          Player Summary
                        </p>
                        <span>|</span>
                        <p onClick={() => handleLineUpNavigate(v?.teamScore?.teamId, v?.name)}>
                          Line Up
                        </p>
                      </div>
                      <div className='ls_card'>
                        <div className='ls_serial_number'>
                          <p>{i + 1}</p>
                        </div>
                        <div
                          className='ls_team_name'
                          onMouseOver={() => setHoverId(v?._id)}
                          onMouseLeave={() => setHoverId('')}
                          onClick={() =>
                            handleRosterNavigate(v?.teamScore?.teamId, v?.name, v?.logo)
                          }
                        >
                          <img src={v?.logo} />
                          <p className={`${hoverId === v?._id ? 'ls_team_name_hover' : ''}`}>
                            {v?.name}
                          </p>
                        </div>
                        <div className='ls_other_column'>
                          <p>{Number(v?.teamScore?.teamScore?.pf).toFixed(2) || '-'}</p>
                        </div>
                        <div className='ls_other_column'>
                          <p>-</p>
                        </div>
                        <div className='ls_other_column'>
                          <p>-</p>
                        </div>
                        <div className='ls_other_column'>
                          <p>-</p>
                        </div>
                        <div className='ls_other_column'>
                          <p>-</p>
                        </div>
                        <div className='ls_other_column'>
                          <p>-</p>
                        </div>
                        <div className='ls_other_column'>
                          <p>-</p>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default LeagueStandings
